import { createGenericContext } from "../../../utils/createGenericContext";
export const [SelectedCisContext, useSelectedCisContext] = createGenericContext([]);
